import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import {
  CreateDocumentResourceSectionPayload,
  createDocumentTemplateResourceSectionAction,
} from '../../actions';
import { createDocumentResourceSection } from '../../slices';
import { saveDocumentTemplate } from '../_save-template';

function* createDocumentTemplateDefaultSection(
  action: PayloadAction<CreateDocumentResourceSectionPayload>,
) {
  const {
    payload: {
      docId,
      resourceSectionId = floatUid(),
      resourceSectionName,
      resourceType,
      sectionId,
    },
  } = action;

  try {
    yield put(
      createDocumentResourceSection({
        docId,
        resourceSectionId,
        resourceSectionName,
        resourceType,
        sectionId,
      }),
    );

    yield saveDocumentTemplate(docId);
  } catch (error) {
    logger.log('an error creating a task section in the document', { error });

    message.error('There was an error creating a task section in the document');
  }
}
export const watchCreateDocumentTemplateResourceSectionSaga = function* () {
  yield takeLatest(
    createDocumentTemplateResourceSectionAction.type,
    createDocumentTemplateDefaultSection,
  );
};
